import { create, StoreApi, UseBoundStore } from 'zustand';

import { SortingState } from '@tanstack/react-table';

import FilterValueArray from 'models/filterValues/FilterValueArray';

import { FilterState } from './types';

export type ReferralsFilterState = FilterState<FilterValueArray>;

type ReferralsActions = {
  setFilters: (filters: ReferralsFilterState) => void;
  setSort: (sort: SortingState) => void;
  setSearch: (search: string) => void;
  removeFilter: (filterKey: string, id: string) => void;
  setExpanded: (expanded: boolean) => void;
  reset: () => void;
};

export type ReferralsState = {
  filters: ReferralsFilterState;
  sort: SortingState;
  search: string;
  actions: ReferralsActions;
  expanded: boolean;
};

const createReferralsStore = (): [
  useStore: UseBoundStore<StoreApi<ReferralsState>>,
  useActions: () => ReferralsActions,
] => {
  const useStore = create<ReferralsState>((set) => ({
    filters: {},
    sort: [{ id: 'createdAt', desc: true }],
    search: '',
    expanded: false,
    actions: {
      setFilters: (filters) => set({ filters }),
      setSort: (sort) => set({ sort }),
      setSearch: (search) => set({ search }),
      removeFilter: (filterKey, id) =>
        set((state) => ({
          filters: {
            ...state.filters,
            ...(state.filters[filterKey] ? { [filterKey]: state.filters[filterKey].removeFilter(id) } : {}),
          },
        })),
      setExpanded: (expanded) => set({ expanded }),
      reset: () => set({ search: '', filters: {} }),
    },
  }));

  const useActions = () => useStore((state) => state.actions);

  return [useStore, useActions];
};

export const [useReferralsStore, useReferralsActions] = createReferralsStore();
